import { render, staticRenderFns } from "./UsersManager.vue?vue&type=template&id=96e20526&scoped=true&"
import script from "./UsersManager.vue?vue&type=script&lang=js&"
export * from "./UsersManager.vue?vue&type=script&lang=js&"
import style0 from "./UsersManager.vue?vue&type=style&index=0&id=96e20526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e20526",
  null
  
)

export default component.exports